import { useNavigate } from "react-router-dom";
import "./PushNotification.css";
import { useState } from "react";
import axios from "axios";

const PushNotification = () => {
  const [userType, setUserType] = useState("");
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [link, setLink] = useState("");
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = { userType, title, message, link };

    try {
      const response = await axios.post(
        `${API_BASE_URL}/admin/notifications`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (response.status === 201) {
        alert("Notification sent successfully!");
        navigate("/all-push-notification");
      }
    } catch (error) {
      console.error("Error sending notification:", error);
      alert("Failed to send notification. Please try again.");
    }
  };

  return (
    <>
      <div id="push-notification-main">
        <div className="heading-or-nav-btns">
          <h4>Notification</h4>
          <div>
            <button>Notification</button>
            <button onClick={() => navigate("/all-push-notification")}>
              All Notifications
            </button>
          </div>
        </div>
        <div className="push-notification-inner  mt-3">
          <form onSubmit={handleSubmit}>
            <div className="push-notification-input">
              <label>
                <b>Notification Send - Student/Teacher</b>
              </label>
              <select
                value={userType}
                onChange={(e) => setUserType(e.target.value)}
              >
                <option value="">--Select--</option>
                <option value="student">Student</option>
                <option value="teacher">Teacher</option>
              </select>
            </div>
            <div className="push-notification-input">
              <label>
                <b>Title</b>
              </label>
              <input
                type="text"
                placeholder="Enter Title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
            <div className="push-notification-input">
              <label>
                <b>Message</b>
              </label>
              <input
                type="text"
                placeholder="Enter Message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
            </div>
            <div className="push-notification-input">
              <label>
                <b>Link</b>
              </label>
              <input
                type="text"
                placeholder="Enter Link"
                value={link}
                onChange={(e) => setLink(e.target.value)}
              />
            </div>
            <div className="new-chapter-form-buttons">
              <button type="submit" className="new-chapter-submit-btn">
                Save
              </button>
              <button
                type="button"
                className="new-chapter-cancel-btn"
                onClick={() => navigate("/all-push-notification")}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default PushNotification;
